export enum MediaViewerFileType {
  IMAGE,
  PDF,
}
